import { faCircleInfo } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@repo/videa-components/src/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
} from '@repo/videa-components/src/ui/dialog';
import classNames from 'classnames';
import { useHistory, useLocation } from 'react-router';

import { useGetPracticeGroups } from '@/react-query/insights/usePracticeGroups';

import { AiBenchmarksInfographic } from './AiBenchmarksInfographic';

const HeaderItem = ({
  children,
  dataCy,
  onClick,
  selected,
}: {
  children: React.ReactNode;
  dataCy?: string;
  onClick?: () => void;
  selected?: boolean;
}) => {
  return (
    <button
      className={classNames(
        'vai-block vai-font-inter vai-cursor-pointer vai-border-0 vai-bg-transparent vai-p-0 vai-m-0 vai-outline-none focus:vai-ring-0 select-none focus:vai-outline-none active:vai-bg-transparent',
        'hover:vai-text-gray-600',
        !selected && 'vai-text-muted-foreground vai-border-transparent',
        selected && 'vai-text-gray-600',
      )}
      data-cy={dataCy}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export const Breadcrumbs = ({
  practiceName,
  providerName,
}: {
  practiceName?: string;
  providerName?: string;
}) => {
  const location = useLocation();
  const history = useHistory();
  const insightsPath =
    location.pathname.split('insights')[0] +
    'insights/' +
    (location.pathname.includes('hygiene') ? 'hygiene' : 'clinical');

  const regionId =
    location.pathname.split('region/')[1]?.split('/')[0] === 'undefined'
      ? undefined
      : location.pathname.split('region/')[1]?.split('/')[0];
  const practiceId =
    location.pathname.split('practice/')[1]?.split('/')[0] === 'undefined'
      ? undefined
      : location.pathname.split('practice/')[1]?.split('/')[0];
  const providerId =
    location.pathname.split('provider/')[1]?.split('/')[0] === 'undefined'
      ? undefined
      : location.pathname.split('provider/')[1]?.split('/')[0];

  const { data: practiceGroups } = useGetPracticeGroups();

  const regionName = practiceGroups?.data.find(
    (group) => group.id.toString() === regionId,
  )?.name;

  return (
    <div className="vai-flex vai-flex-row vai-justify-between vai-items-center vai-h-8">
      {regionId?.length || practiceId?.length || providerId?.length ? (
        <div className="vai-flex vai-flex-row vai-gap-4 vai-items-center">
          <HeaderItem
            onClick={() => {
              history.push({ pathname: insightsPath, search: location.search });
            }}
          >
            Insights
          </HeaderItem>
          {regionId?.length && regionName && (
            <>
              <FontAwesomeIcon icon={faChevronRight} color="gray" />
              <HeaderItem
                onClick={() => {
                  history.push({
                    pathname: `${insightsPath}/region/${regionId}`,
                    search: location.search,
                  });
                }}
              >
                {regionName}
              </HeaderItem>
            </>
          )}
          {practiceId?.length && practiceName && (
            <>
              <FontAwesomeIcon icon={faChevronRight} color="gray" />
              <HeaderItem
                onClick={() => {
                  history.push({
                    pathname: `${insightsPath}/region/${regionId}/practice/${practiceId}`,
                    search: location.search,
                  });
                }}
              >
                {practiceName}
              </HeaderItem>
            </>
          )}
          {providerId?.length && providerName && (
            <>
              <FontAwesomeIcon icon={faChevronRight} color="gray" />
              <HeaderItem>{providerName}</HeaderItem>
            </>
          )}
        </div>
      ) : (
        <h1 className="vai-typography-h3">Insights</h1>
      )}
      {location.pathname.includes('clinical') && (
        <Dialog>
          <DialogTrigger>
            <div className="vai-flex vai-flex-row vai-gap-2 vai-items-center hover:vai-bg-zinc-100 vai-p-2 vai-rounded-md">
              <FontAwesomeIcon
                icon={faCircleInfo}
                className="vai-text-gray-400"
              />
              <span className="vai-typography-muted">
                What are AI benchmarks?
              </span>
            </div>
          </DialogTrigger>
          <DialogContent className="!vai-w-auto !vai-p-8">
            <AiBenchmarksInfographic />
            <DialogClose className="vai-flex vai-justify-end">
              <Button variant="default">Got it!</Button>
            </DialogClose>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};
